import { render, staticRenderFns } from "./DispatchFormExtra.vue?vue&type=template&id=974212f4&scoped=true"
import script from "./DispatchFormExtra.vue?vue&type=script&lang=js"
export * from "./DispatchFormExtra.vue?vue&type=script&lang=js"
import style0 from "./DispatchFormExtra.vue?vue&type=style&index=0&id=974212f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974212f4",
  null
  
)

export default component.exports